import React, {useState, useEffect} from "react";
import useAxios from "../../utils/useAxios";
import {useTranslation} from "react-i18next";
import { tournamentCache, tournamentSubscribers } from "../../utils/tournamentCache";

const TournamentBlockToggle = ({ tournamentId, tournamentBlocks = [], setTournament, blockType }) => {
    const api = useAxios();
    const { t } = useTranslation();

    const block = tournamentBlocks.find(b => b.block_type === blockType);
    const initialActive = block ? block.is_active : true;

    const [active, setActive] = useState(initialActive);

    useEffect(() => {
        setActive(initialActive);
    }, [initialActive]);

    const toggle = async () => {
        const nextState = !active;
        setActive(nextState);
        if (setTournament) {
            setTournament(prev => {
                if (!prev) return prev;
                const blocksArray = prev.blocks ? [...prev.blocks] : [];
                const idx = blocksArray.findIndex(b => b.block_type === blockType);

                if (idx !== -1) {
                    blocksArray[idx] = { ...blocksArray[idx], is_active: nextState };
                } else {
                    blocksArray.push({ block_type: blockType, is_active: nextState });
                }
                const updatedTournament = { ...prev, blocks: blocksArray };
                if (tournamentId) {
                    tournamentCache[tournamentId] = updatedTournament;
                    tournamentSubscribers.forEach(cb => cb(tournamentId, updatedTournament));
                }
                return updatedTournament;
            });
        }

        try {
            await api.post(
                `/api/v1.0/tournaments/${tournamentId}/block-status/?block_type=${blockType}`
            );
        } catch (e) {
            console.error(e);
            setActive(!nextState);
        }
    };

    return (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span>{t("View")}</span>
            <input type="checkbox" checked={active} onChange={toggle} style={{ cursor: "pointer", margin: 0 }} />
        </div>
    );
};

export default TournamentBlockToggle;
